import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/select.js';
import { DEFAULT_UI_LANGUAGE, isUiLanguage } from '@/lib/locale.js';

export function LanguageSwitcher(): JSX.Element {
  const { i18n, t } = useTranslation();
  const value = isUiLanguage(i18n.resolvedLanguage) ? i18n.resolvedLanguage : DEFAULT_UI_LANGUAGE;

  return (
    <Select value={value} onValueChange={(language) => void i18n.changeLanguage(language)}>
      <SelectTrigger aria-label={t('common.language')} className="w-[160px] gap-2 bg-transparent">
        <Languages size={16} aria-hidden="true" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="uk">{t('common.ukrainian')}</SelectItem>
        <SelectItem value="en">{t('common.english')}</SelectItem>
      </SelectContent>
    </Select>
  );
}
